<template>
  <div class="topBar">
    <el-button size="large" type="primary" @click="addAd">添加通知</el-button>
  </div>
  <div class="switchBar">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="id" prop="id" />
      <el-table-column label="标题" prop="title" />
      <el-table-column label="信息" prop="info" />
      <el-table-column label="标号" prop="signOrder" />
      <el-table-column label="创建时间" prop="createTime" align="center" />
    </el-table>
    <el-dialog
      v-model="dialogVisible"
      width="500"
      draggable
      :show-close="false"
    >
      <el-form :model="form" label-width="auto" style="max-width: 600px">
        <el-form-item label="标题">
          <el-input
            v-model="form.title"
            type="text"
            maxlength="20"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="信息">
          <el-input
            v-model="form.info"
            type="textarea"
            :autosize="{ minRows: 5 }"
          />
        </el-form-item>
      </el-form>

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitReply">
            {{ isAdd ? "增加" : "修改" }}
          </el-button>
        </div>
      </template>
    </el-dialog>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>

  <div class="zhanwei3"></div>
</template>

<script lang="ts">
import { defineComponent, markRaw } from "vue";
import {
  Right,
  FolderChecked,
  Plus,
  More,
  ArrowLeft,
  AlarmClock,
  QuestionFilled,
  Location,
  Picture as IconPicture,
  Delete,
} from "@element-plus/icons-vue";
import {
  ElMessage,
  ElMessageBox,
  ElNotification,
  TabsPaneContext,
} from "element-plus";
import { Form } from "@/views/view";
export default defineComponent({
  name: "App",
  data(): any {
    return {
      currentPage: 1,
      total: 1,
      dialogImageUrl: "",
      dialogVisible: false,
      activeName: "first",
      tableData: [],
      status: 0,
      isAdd: false,
      centerDialogVisible: false,
      form: {
        title: "",
        info: "",
      },
    };
  },
  components: {
    Right,
    FolderChecked,
    Plus,
    More,
    ArrowLeft,
    AlarmClock,
    QuestionFilled,
    Location,
    IconPicture,
  },
  computed: {
    doubledCounter(): number {
      return this.counter * 2;
    },
    allowUpload() {
      return this.form.advImg !== "";
    },
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
  },
  mounted() {},
  created() {
    this.fetchAdvertises(this.currentPage, this.status);
  },
  methods: {
    fetchAdvertises(pageNum: number) {
      const pageSize = 10;
      this.dialogVisible = false;
      this.$store
        .dispatch("user/getNotices", { pageNum, pageSize })
        .then((res: any) => {
          console.log(res);
          this.tableData = res.records;
          this.total = res.total;
        })
        .catch((err: any) => {
          ElMessage({
            message: err,
            type: "warning",
          });
        });
    },
    handleCurrentChange(val: number) {
      this.fetchAdvertises(val, this.status);
    },
    handleEdit(row: Form) {
      this.dialogVisible = true;
      this.isAdd = false;
      this.form = row;
    },
    handleClick(tab: TabsPaneContext) {
      this.status = tab.paneName === "first" ? 0 : 2;
      this.fetchAdvertises(1, this.status);
    },
    quash(index: number, data: any) {
      this.updateGame(index, data.id);
    },
    updateGame(status: number, userId: string) {
      this.$store
        .dispatch("game/UpdateUserStatus", { status: status, userId: userId })
        .then((res: any) => {
          this.handleCurrentChange(this.currentPage);
        })
        .catch(() => {});
    },
    handleAvatarSuccess(response: any) {
      this.form.advImg = response.data.returnFileUrl;
    },
    beforeAvatarUpload(file: File) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        ElNotification.warning({
          message: "请上传png/jpg",
          offset: 100,
          duration: 3000,
        });
        return false;
      }
      if (!isLt2M) {
        ElNotification.warning({
          message: "图片必须小于5m",
          offset: 100,
          duration: 3000,
        });
        return false;
      }

      // Display uploaded avatar
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.form.advImg = reader.result as string;
      };

      return true;
    },
    clearImage() {
      this.form.advImg = "";
      this.fileList = [];
    },
    submitReply() {
      this.form.signOrder = this.total + 1;

      console.log(this.form);

      this.$store
        .dispatch("user/addNotice", this.form)
        .then((res: any) => {
          this.fetchAdvertises();
        })
        .catch((err: any) => {
          ElMessage({
            message: err || "添加失败",
            type: "error",
          });
        });

      // if (this.isAdd) {
      //   this.$store
      //     .dispatch("user/addAdertise", restForm)
      //     .then((res: any) => {
      //       this.fetchAdvertises();
      //     })
      //     .catch((err: any) => {
      //       ElMessage({
      //         message: err || "添加失败",
      //         type: "error",
      //       });
      //     });
      // } else {
      //   this.$store
      //     .dispatch("user/editAdvertise", this.form)
      //     .then((res: any) => {
      //       this.fetchAdvertises();
      //     })
      //     .catch((err: any) => {
      //       ElMessage({
      //         message: err || "修改成功",
      //         type: "error",
      //       });
      //     });
      // }
    },
    addAd() {
      this.dialogVisible = true;
      this.isAdd = true;
    },
    deleteAd(id: string) {
      ElMessageBox.confirm("是否删除广告", "Warning", {
        type: "warning",
        icon: markRaw(Delete),
        confirmButtonText: this.$t("List.confirm"),
        cancelButtonText: this.$t("List.channel"),
        draggable: true,
        overflow: true,
      })
        .then(() => {
          this.$store
            .dispatch("user/deleteAd", { id: id })
            .then((res: any) => {
              if (res == 1) {
                this.fetchAdvertises();
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
  },
});
</script>

<style lang="less" scoped>
.switchBar {
  width: 100%;
  height: auto;
}

.topBar {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: flex-start;
  padding-left: 20px;
  align-items: center;
}

.pagination {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
